import { MetricFormat, WidgetKind, type Report } from 'corso-admin-ui';
import { isProtected } from './filters';

const carbon = {
  kind: WidgetKind.kpi,
  metric: 'carbonGrams',
  filters: isProtected,
} as const;

export const sustainability = {
  key: 'sustainability',
  label: 'Sustainability',
  dataset: 'orders',
  timeFields: ['orderedOn'],
  widgets: [
    {
      ...carbon,
      title: 'Carbon offset (metric tons)',
      description: 'On protected orders',
    },
    {
      ...carbon,
      title: 'Miles driven',
      description: 'A gas car emits as much over this distance',
      format: MetricFormat.gramsAsMilesDriven,
    },
    {
      ...carbon,
      title: 'Trees planted',
      description: 'This many trees absorb as much',
      format: MetricFormat.gramsAsTreesPlanted,
    },
    {
      ...carbon,
      title: 'Air conditioned (hours)',
      description: 'Air conditioning emits as much in this time',
      format: MetricFormat.gramsAsHoursAirConditioned,
    },
    {
      ...carbon,
      title: 'Home electricity (days)',
      description: 'Powering a home emits as much in this time',
      format: MetricFormat.gramsAsDaysOfHomeElectricity,
    },
  ],
} as const satisfies Report;
